import { useDispatch } from "react-redux";
import { useCallback, useMemo } from "react";
import { SwitchAccountAction } from "store/middlewares/session/auth";
import { urls } from "config/urls";

export const PENDING_NOTIFICATION_KEY = "pendingNotification";

// Pure navigation mapper – kept exactly as you had it
export const notificationNavigation = (payload) => {
  console.log(payload, "notification");
  let url = "";

  const type = (payload?.type || "").toLowerCase();

  switch (type) {
    case "new_login":
      url = "/drive/home";
      break;

    case "file_shared":
    case "folder_shared":
      url = "/drive/sharedwithme";
      break;

    default:
      url = "/drive/home";
      break;
  }

  return url;
};

export const useResolveNotificationUrl = () => {
  const dispatch = useDispatch();

  const user = useMemo(
    () => JSON.parse(localStorage.getItem("bigfoot-drive"))?.user,
    [],
  );

  const redirectUrl = `${urls.DRIVE_URL || window.location.origin}/drive/home`;
  const accountLoginUrl = urls.ACCOUNT_URL;

  const LOG = "[NOTIF-SWITCH]";

  const resolveUrl = useCallback(
    (payload) => {
      const payloadEmail = (payload?.email || "").toLowerCase();
      const payloadUserId = payload?.user_id;

      console.log(LOG, "1. payload", payload);
      console.log(LOG, "2. current user", {
        id: user?.id,
        email: user?.email,
        accountsOnDevice: user?.accountsOnDevice,
      });

      const needsAccountSwitch =
        !!payloadUserId && payloadUserId !== user?.id;

      console.log(LOG, "3. needsAccountSwitch", needsAccountSwitch, {
        payloadUserId,
        currentUserId: user?.id,
        sameType: typeof payloadUserId === typeof user?.id,
      });

      if (!needsAccountSwitch) {
        return Promise.resolve(notificationNavigation(payload));
      }

      const redirectToLogin = (reason, extra) => {
        console.error(LOG, "REDIRECT TO LOGIN. reason:", reason, extra);
        console.trace(LOG, "redirect trace");
        sessionStorage.setItem(
          "notifSwitchLastError",
          JSON.stringify({ reason, time: new Date().toISOString() }),
        );
        window.location.href = `${accountLoginUrl}?redirect=${encodeURIComponent(
          redirectUrl,
        )}`;
      };

      const targetAccount = user?.accountsOnDevice?.find(
        (account) =>
          (account?.user?.email || "").toLowerCase() === payloadEmail &&
          account.is_accessible === true,
      );

      console.log(LOG, "4. targetAccount", targetAccount);

      if (!targetAccount) {
        const found = user?.accountsOnDevice?.find(
          (a) => (a?.user?.email || "").toLowerCase() === payloadEmail,
        );
        redirectToLogin("account not on device or not accessible", { found });
        return Promise.resolve(null);
      }

      return new Promise((resolve) => {
        const otherEmails =
          user?.accountsOnDevice
            ?.map((account) => account?.user?.email)
            ?.filter(
              (email) => (email || "").toLowerCase() !== payloadEmail,
            ) || [];

        console.log(LOG, "5. dispatch SwitchAccountAction", {
          email: payloadEmail,
          emails: otherEmails,
          deviceId: user?.userSession?.device_id,
        });

        dispatch(
          SwitchAccountAction({
            email: payloadEmail,
            // emails: [...otherEmails, user?.email],
            deviceId: user?.userSession?.device_id,
            appType: "drive",
            onSuccess: (res) => {
              console.log(LOG, "6. switch onSuccess", res);
              console.log(
                LOG,
                "7. localStorage bigfoot-drive before reload",
                localStorage.getItem("bigfoot-drive"),
              );
              try {
                sessionStorage.setItem(
                  PENDING_NOTIFICATION_KEY,
                  JSON.stringify(payload),
                );
              } catch (e) {
                console.error(LOG, "sessionStorage set failed", e);
              }
              console.log(LOG, "8. reloading now");
              window.location.reload();
              resolve(null);
            },
            onError: (err) => {
              console.error(LOG, "switch onError", err);
              redirectToLogin("SwitchAccountAction onError", err);
              resolve(null);
            },
          }),
        );
      });
    },
    [user, dispatch, redirectUrl, accountLoginUrl],
  );

  return resolveUrl;
};